<script lang="ts">
import { useUserStore, useConfigStore  } from '~/store'

export default {
    name: 'MenuUserProfile',
    props: {
        loginColor: { type: String, required: false },
        appSlug : { type: String, required: false },
        titleConnexionModal: { type: String, required: false },
    },
    setup() {
        const access_token = useCookie<string>('access_token')
        const configStore = useConfigStore()

        return {
            access_token,
            configStore,
        }
    },
    data: () => ({
        menu: false,
        message: false
    }),
    mounted () {
        this.getAccessRequestNumber()
    },
    computed : {
        isSameDomainName () {
            if (process.browser) {
                return window.location.origin === this.configStore.currentConfig.admin_app_url
            }
            return
        },
        currentUser () {
            return this.$currentUser()
        },
        appInfo () {
            return this.configStore?.currentConfig?.app_info
        },
      applicationRole () {
        const ar=this.$currentUser()?.application_roles?.find((i)=>{
          return i.application?.slug === this.appInfo?.slug
        })?.role
        return ar ? this.$translate('default.utilisateurs.application_roles.role.'+ar) : null
      },

    },
    watch : {
        currentUser () {
                this.getAccessRequestNumber()
        },
        appInfo () {
            this.getAccessRequestNumber()
        }
    },
    methods: {
        getAccessRequestNumber() {
            if (this.currentUser?.role && this.currentUser.role !== 'user' && this.currentUser.role !== 'guest') {
                this.$api.setRequest({
                    url: `access-requests`,
                    query: this.appInfo?.id ? { application : this.appInfo.id} : {},
                    method: "GET",
                }).then((res: { meta: { total: any; }; }) => {
                    this.configStore.currentConfig.access_request_total = res.meta.total
                })
            } else {
                this.configStore.currentConfig.access_request_total = null
            }

        },
        accessRightAdminRedirect () {
            let url = `${this.configStore.currentConfig.admin_app_url}/demandes-acces`
            if (this.appInfo?.slug)
                url += `?application=${this.appInfo.slug}`

            this.redirect(url)
        },
        redirect (url: string) {
            if (process.browser) {
                window.location.href = url
            }
        },
        async logout() {
            const userStore = useUserStore()
            await this.$api.setRequest({
                url: 'logout',
                method: 'POST',
            })
            useCookie<string>('access_token').value = null
            this.access_token = null
            await userStore.clearUser()
            this.$router.push('/')
        },
    },
}
</script>

<template>
    <client-only>
        <div v-if="$currentUser().k" :class="$vuetify.display.smAndDown && 'text-center mx-2'">
            <v-menu v-model="menu" :close-on-content-click="false" location="bottom">
                <template #activator="{ props }">
                    <v-btn v-bind="props" class="mr-2" id="profile-dropdown" :class="$vuetify.display.smAndDown && 'bg-primary'" :density="$vuetify.display.smAndDow ? 'compact' : 'default'"  :block="$vuetify.display.smAndDown ? true : false">
                        <span class="text-capitalize" :title="'organisation: '+$currentUser().organization.name+ (applicationRole?' [accès: '+applicationRole+']' : '' )">{{ $currentUser().name }}</span>
                        <template v-if="$currentUser().role">
                            <span v-if="$vuetify.display.smAndUp" class="mx-2">-</span>
                            <span class="text-uppercase">{{ $translate(`utilisateurs.role.${$currentUser().role}`) }}</span>
                        </template>
                        <v-icon class="ml-2" :icon="menu ? 'mdi-menu-up' : 'mdi-menu-down'"></v-icon>
                    </v-btn>
                </template>

                <v-card min-width="300" variant="flat" color="light">
                    <v-list density="compact" selectable class="pa-0" bg-color="primary" @click.prevent="menu = false">
                        <template v-if="($currentUser().role === 'admin' || $currentUser().role === 'manager') && !isSameDomainName">
                            <v-list-item :href="configStore.currentConfig.access_request_total" color="info" @click.prevent="accessRightAdminRedirect">
                                <template v-slot:prepend>
                                    <v-icon icon="mdi-account-lock"></v-icon>
                                </template>
                                <v-list-item-title>Demandes d'accès</v-list-item-title>
                                <template #append v-if="configStore.currentConfig.access_request_total">
                                    <v-badge
                                        color="warning"
                                        :content="configStore.currentConfig.access_request_total"
                                        inline
                                    />
                                </template>
                            </v-list-item>
                            <v-list-item :href="configStore.currentConfig.admin_app_url" color="info" @click.prevent="redirect(configStore.currentConfig.admin_app_url)">
                                <template v-slot:prepend>
                                    <v-icon icon="mdi-cog"></v-icon>
                                </template>
                                <v-list-item-title>Administration</v-list-item-title>
                            </v-list-item>
                            <v-divider />
                        </template>
                        <v-list-item :href="configStore.currentConfig.portail_app_url" color="info" @click.prevent="redirect(configStore.currentConfig.portail_app_url)">
                            <template v-slot:prepend>
                                <v-icon icon="mdi-view-grid"></v-icon>
                            </template>
                            <v-list-item-title>Portail</v-list-item-title>
                        </v-list-item>

                        <v-list-item href="/profil" color="info" @click.prevent="$router.push('/profil')">
                            <template v-slot:prepend>
                                <v-icon icon="mdi-account"></v-icon>
                            </template>
                            <v-list-item-title>Mon compte</v-list-item-title>
                        </v-list-item>
                        <v-list-item href="/" color="info" @click.prevent="logout()">
                            <template v-slot:prepend>
                                <v-icon icon="mdi-power-standby"></v-icon>
                            </template>
                            <v-list-item-title>Déconnexion</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-card>
            </v-menu>
        </div>
        <div v-else class="mx-5 d-block d-sm-flex">
            <template v-if="$slots.loginbuttons">
                <slot name="loginbuttons" />
            </template>
            <template v-else>
                <MenuAppbarConnexionButton ref="loginButton" :login-color="loginColor" :title-modal="titleConnexionModal" @launchRegister="$refs?.registerButton?.$refs?.registerForm?.showModal()" />
                <div class="mb-2" />
                <MenuAppbarRegisterButton ref="registerButton" :login-color="loginColor" @openConnexionModal="$refs?.loginButton?.$refs?.loginForm?.showModal()" />
            </template>
        </div>
    </client-only>
</template>
